import { Button, Col, ConfigProvider, Modal, Radio, Row } from "antd";
import { DatePicker as DatePickerJalali, JalaliLocaleListener } from "antd-jalali";
import fa_IR from "antd/lib/locale/fa_IR";
import Table, { ColumnsType } from "antd/lib/table";
import { useEffect, useState } from "react";
import { Bar, BarChart, CartesianGrid, Cell, Label, Tooltip, XAxis, YAxis } from "recharts";
import { getSepasReport } from '../../api/api';
import Spinner from "../../components/_common/Spinner";
import { errorNotify } from "../../services/toast.notification";
import './style.css';
import toast from 'react-hot-toast';
import { DownloadOutlined } from '@ant-design/icons';
import DownloadPDF from "../../components/_common/DownloadZipFile/DownloadPdfFile";

export interface InputProps {
  url: any
}

const SepasReport = ({ url }: InputProps) => {

  const columns: ColumnsType<any> = [

    { title: 'شماره پذیرش ', dataIndex: 'Str_AdmitPatient', key: 'Str_AdmitPatient' },
    { title: 'کد ملی', dataIndex: 'Int_NationalCode', key: 'Int_NationalCode' },
    { title: ' نام و نام خانوادگی', dataIndex: 'Str_FLName', key: 'Str_FLName' },
    { title: 'تاریخ پذیرش ', dataIndex: 'Str_PerAdmitDate', key: 'Str_PerAdmitDate' },
    { title: 'زمان پذیرش ', dataIndex: 'Str_AdmitTime', key: 'Str_AdmitTime' },
    {
      title: 'وضعیت',
      dataIndex: 'Str_InsOnlineAdmit',
      key: 'Str_InsOnlineAdmit',
      render: (value) => (
        value === 'موفق'
          ? <span style={{ color: 'green', fontWeight: 'bold' }}>موفق</span>
          : value === 'ناموفق' ? <span style={{ color: 'red', fontWeight: 'bold' }}>ناموفق</span> :
            <span style={{ color: 'yellow', fontWeight: 'bold' }}>ارسال نشده</span>
      ),
    },
    { title: 'کد رهگیری', dataIndex: 'Str_InsTrsID', key: 'Str_InsTrsID' },
    { title: 'توضیحات ', dataIndex: 'Str_LogDescription', key: 'Str_LogDescription' },
  ];



  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState([]);
  const [firstDate, setFirstDate] = useState<any>(undefined);
  const [lastDate, setLastDate] = useState<any>(undefined);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [StateRadioVal, setStateRadioVal] = useState(-1);
  const [filteredData, setFilteredData] = useState<any[]>(data);
  const [mode, setMode] = useState(0);

  let chartData: any[] = [];
  const color = ["#12e4dd", "#f49f17"]
  let flag = false;

  const legendLabel = [
    {
      name: 'count', value: "تعداد کل انجام شده"
    },
    {
      name: 'failedCount', value: "هشدار تعداد غیرمجاز"
    }

  ];
  const _getSepasReport = (firstDateEn: string, lastDateEn: string) => {
    setIsLoading(true);
    let flag = false;

    getSepasReport(url, firstDateEn, lastDateEn, mode, false)
      .then((result: any) => {
        setFilteredData(result.InsOnlineAdmit);

        // chartData.push({name:"موفق", count:10,failedCount:0});
        // chartData.push( {name:"ناموفق", count:15,failedCount:0});
        // chartData.map((item:any)=>{
        //   if(item.count !==0 ) {
        //     flag = true;
        //     return;
        //   }
        // })
        setIsLoading(false);
      })
      .catch((error) => {
        console.log(error);
        errorNotify(error.response.data.errorMessage, undefined, 5000)
      })
  }

  const _getSepasReportPDF = () => {
    const toastId = toast.loading('...درحال آماده سازی فایل گزارش سپاس');
    getSepasReport(url, firstDate.format('YYYY/MM/DD'), lastDate.format('YYYY/MM/DD'), mode, true)
      .then((result: any) => {
          DownloadPDF(result.Base64, "گزارش سپاس");
          toast.dismiss(toastId);
        
      })
      .catch((error) => {
        toast.dismiss(toastId);

        console.log(error);
        errorNotify(error.response.data.errorMessage, undefined, 5000)
      })
  }

  const getChartData = () => {
    // data.map((item:any)=>{
    chartData.push({ name: "موفق", count: filteredData.filter((a: any) => a.Int_InsOnlineAdmitState == 1).length, color: 'green' });
    chartData.push({ name: "ارسال نشده", count: filteredData.filter((a: any) => a.Int_InsOnlineAdmitState == 0).length, color: 'yellow' });
    chartData.push({ name: "ناموفق", count: filteredData.filter((a: any) => a.Int_InsOnlineAdmitState == 2).length, color: 'red' });

    //})

    chartData.map((item: any) => {
      if (item.count !== 0) {
        flag = true;
        return;
      }
    })
  }
  const onChangeDatePicker = (dates: any, dateStrings: any) => {

    console.log(dates);
    if (!dateStrings) return;
    if (dateStrings.length < 2) return;
    if (dateStrings[0] === "") return;
    if (dateStrings[1] === "") return;

    setFirstDate(dates[0])
    setLastDate(dates[1])

    _getSepasReport(dates[0].format('YYYY/MM/DD'), dates[1].format('YYYY/MM/DD'));
  }

  const onChangeMode = (e: any) => {
    setMode(e.target.value);
  };

  const showModal = () => {
    setIsModalOpen(true);
  };

  const onCancel = () => {
    setIsModalOpen(false);
  };

  const onChangeStateRadio = (e: any) => {
    const value = e.target.value;
    setStateRadioVal(value);

    let newData = data;

    if (value === 1) {
      // فقط موفق
      newData = data.filter((d: any) => d.Int_InsOnlineAdmitState === 1);
    } else if (value === 2) {
      // فقط ناموفق
      newData = data.filter((d: any) => d.Int_InsOnlineAdmitState === 2 || d.Int_InsOnlineAdmitState === 0);
    }
    setFilteredData(newData);
  };

  useEffect(() => {
    onChangeStateRadio({ target: { value: StateRadioVal } });
  }, [data]);

  return (
    <>

      <div className="tab-content-padding">
        <center style={{ paddingTop: '15px' }}>
          <div style={{ marginBottom: '15px', textAlign: 'center' }}>
            <Radio.Group onChange={onChangeMode} value={mode}>
              <Radio value={0}>براساس تاریخ پذیرش</Radio>
              <Radio value={1}>براساس تاریخ ارسال</Radio>
            </Radio.Group>
          </div>

          <div className="calender" >
            <ConfigProvider locale={fa_IR} direction="rtl">
              <JalaliLocaleListener />
              <DatePickerJalali.RangePicker value={[firstDate, lastDate]} onCalendarChange={(dates: any, dateStrings: any) => onChangeDatePicker(dates, dateStrings)} />
            </ConfigProvider>
          </div>
        </center>
        
          {filteredData.length > 0 &&  (
            <>
             
              <Row>
                <Col lg={12} md={12} sm={24} xs={24}>
                  <Radio.Group
                    onChange={onChangeStateRadio} value={StateRadioVal}>
                    <div>
                      <Radio value={-1}>همه</Radio>
                      <Radio value={1}>موفق</Radio>
                      <Radio value={2}>ناموفق</Radio>
                    </div>


                  </Radio.Group>
                </Col>
                <Col lg={12} md={12} sm={24} xs={24}>
                  <Button type="primary" onClick={showModal} style={{ float: "left" }}>
                    نمایش موفق ها و ناموفق ها بر روی نمودار
                  </Button>
                  <Button style={{ float: "left" ,marginLeft:'5px'}}
                type="primary"
                icon={<DownloadOutlined />}
                onClick={_getSepasReportPDF}
              >
                دانلود گزارش
              </Button>
                </Col>
                
              </Row>
              
                <>



                  <div className="inner-tabs_content">
                    {/* <div style={{display:"flex",justifyContent:"space-between",marginBottom:"5px"}}>
                    <span style={{ color: "green" }}>پرداخت های موفق: {successCount}</span>
                    <span style={{ color: "red" }}>پرداخت های ناموفق: {failedCount}</span>
                  </div> */}
                    <Table scroll={{ x: 1500 }}
                      dataSource={filteredData} columns={columns}
                    />
                  </div>
                </>
              
              {filteredData.length == 0 && (
                <p className="empty-data">داده ای برای نمایش موجود نیست.</p>
              )

              }
            </>
          )
        }
        {
          isLoading === true && (
            <Spinner />
          )
        }
      </div>


      <Modal
        visible={isModalOpen}
        onCancel={onCancel}
        cancelButtonProps={{ style: { display: 'none' } }}
        okButtonProps={{ style: { display: 'none' } }}
      >
        {isLoading === false && (
          getChartData(),
          <>
            {
              flag && (
                //  <OneBarChart data={chartData} label="" dataKey="count"/>
                <BarChart
                  width={500}
                  height={250}
                  data={chartData}
                  margin={{
                    top: 5,
                    right: 30,
                    left: 20,
                    bottom: 5
                  }}
                >
                  <CartesianGrid strokeDasharray="3 3" />
                  <XAxis dataKey="name" />
                  <YAxis>
                    <Label
                      style={{
                        textAnchor: "middle",
                        fontSize: "130%",
                        fill: "black",
                        backgroundColor: 'red'
                      }}
                      angle={270}
                      value={""} /></YAxis>

                  <Tooltip />
                  <Bar dataKey="count" fill="#8884d8">
                    {
                      chartData.map((entry: { color: string | undefined; }, index: any) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                      ))
                    }
                  </Bar>
                  <Bar dataKey="sell" fill="#82ca9d" />
                </BarChart>
              )
            }
            {
              flag === false &&
              (<p className="empty-data">داده ای برای نمایش موجود نیست.</p>)
            }
          </>
        )}
      </Modal>
    </>
  )
}
export default SepasReport;
